import { Routes } from '@angular/router';

import OktaCallbackComponent from './okta-callback/okta-callback.component';
import environment from '../environments/environment';
import AppRouteEnum from './shared/enums/app-route.enum';
import { AuthGuardMatch } from './shared/guards/auth.guard';
import { NoAuthGuardMatch } from './shared/guards/no-auth.guard';

const AppRoutes: Routes = environment.enableDirectLogin
    ? [
          {
              path: 'unauthorized',
              loadChildren: () =>
                  import('./pages/unauthorized/unauthorized.module').then(
                      (m) => m.UnauthorizedModule
                  ),
          },
          {
              path: '',
              redirectTo: 'login',
              pathMatch: 'full',
          },
          {
              path: AppRouteEnum.Login,
              loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule),
              canMatch: [NoAuthGuardMatch],
          },
          {
              path: AppRouteEnum.Aida,
              loadChildren: () => import('./pages/aida/aida.module').then((m) => m.AidaModule),
              canMatch: [AuthGuardMatch],
          },
          // Map the callback route to the OktaCallbackComponent, which handles any tokens returned from the login process
          { path: 'login/callback', component: OktaCallbackComponent },
      ]
    : [
          {
              path: 'unauthorized',
              loadChildren: () =>
                  import('./pages/unauthorized/unauthorized.module').then(
                      (m) => m.UnauthorizedModule
                  ),
          },
          {
              path: '',
              redirectTo: AppRouteEnum.Aida,
              pathMatch: 'full',
          },
          {
              path: AppRouteEnum.Aida,
              loadChildren: () => import('./pages/aida/aida.module').then((m) => m.AidaModule),
              canMatch: [AuthGuardMatch],
          },
          // Map the callback route to the OktaCallbackComponent, which handles any tokens returned from the login process
          { path: 'login/callback', component: OktaCallbackComponent },
      ];

export default AppRoutes;
